export enum MoveNavbarEnum {
  CURRENT = 'active',
  PAST = 'past',
  ACCOUNT = 'account',
}
